<template>
  <b-card no-body class="mb-2">
    <b-card-header class="d-flex align-items-center py-1" style="border-bottom:1px solid #ebe9f1;">
      <feather-icon icon="CalendarIcon" size="16" class="mr-75 text-info" />
      <span class="font-weight-bold" style="font-size:0.95rem;">Datewise Recruiter Performance</span>
      <b-badge variant="light-info" class="ml-75">{{ datewiseAnalytics.length }} rows</b-badge>
    </b-card-header>
    <div class="table-responsive mb-0 datewise-table-scroll">
      <table class="table table-hover table-sm mb-0" style="font-size:0.82rem;">
        <thead style="background:#f8f8f8;">
          <tr>
            <th class="px-1 py-75">Date</th>
            <th class="px-1 py-75">Recruiter</th>
            <th class="px-1 py-75 text-center">Total</th>
            <th class="px-1 py-75 text-center">Connected</th>
            <th class="px-1 py-75 text-center">Not Ans.</th>
            <th class="px-1 py-75 text-center">Failed</th>
            <th class="px-1 py-75 text-center">Inbound</th>
            <th class="px-1 py-75 text-center">Outbound</th>
            <th class="px-1 py-75 text-center">Connect%</th>
            <th class="px-1 py-75 text-center">Occupancy%</th>
            <th class="px-1 py-75 text-center">PS Count</th>
            <th class="px-1 py-75 text-center">Avg Duration</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in datewiseAnalytics" :key="`${r.date}-${r.empId}`">
            <td class="px-1 py-75 text-nowrap">{{ r.date }}</td>
            <td class="px-1 py-75 text-nowrap">{{ r.recruiterName }}</td>
            <td class="px-1 py-75 text-center">{{ r.total }}</td>
            <td class="px-1 py-75 text-center text-success font-weight-bold">{{ r.connected }}</td>
            <td class="px-1 py-75 text-center text-warning">{{ r.notAnswered }}</td>
            <td class="px-1 py-75 text-center text-danger">{{ r.failed }}</td>
            <td class="px-1 py-75 text-center">{{ r.inbound }}</td>
            <td class="px-1 py-75 text-center">{{ r.outbound }}</td>
            <td class="px-1 py-75 text-center">
              <div class="d-flex align-items-center justify-content-center" style="gap:4px;">
                <div style="width:50px;height:6px;background:#eee;border-radius:3px;overflow:hidden;">
                  <div :style="`width:${r.connectionRate}%;height:100%;background:#28c76f;border-radius:3px;`" />
                </div>
                <small>{{ r.connectionRate }}%</small>
              </div>
            </td>
            <td class="px-1 py-75 text-center">
              <div class="d-flex align-items-center justify-content-center" style="gap:4px;">
                <div style="width:50px;height:6px;background:#eee;border-radius:3px;overflow:hidden;">
                  <div :style="`width:${r.occupancy}%;height:100%;background:#7367f0;border-radius:3px;`" />
                </div>
                <small>{{ r.occupancy }}%</small>
              </div>
            </td>
            <td class="px-1 py-75 text-center text-primary font-weight-bold">{{ r.psCount }}</td>
            <td class="px-1 py-75 text-center text-nowrap">{{ r.avgDuration }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BBadge } from 'bootstrap-vue'

export default {
  name: 'MyCallsDatewiseTable',

  components: {
    BCard,
    BCardHeader,
    BBadge,
  },

  props: {
    datewiseAnalytics: { type: Array, required: true },
  },
}
</script>

<style scoped>
.datewise-table-scroll {
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
}

@media (max-width: 576px) {
  .datewise-table-scroll td,
  .datewise-table-scroll th {
    white-space: nowrap;
  }
}
</style>
